import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTarget12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTarget12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Target12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M9.67.767 9.413 0l-.572.572-1.567 1.567-.19.189.053.262.05.247a4.874 4.874 0 1 0 1.977 1.976l.245.05.263.052.189-.19 1.567-1.566.572-.572-.768-.256-1.173-.39zm-1.5 1.89.806-.806.214.642.079.238.237.079.643.214-.806.805-.977-.195zm.578 4.471a3.874 3.874 0 1 1-1.511-3.07l-.552.552a3.102 3.102 0 1 0 .707.707l.552-.551c.504.654.804 1.473.804 2.362M4.875 5.027c.399 0 .772.111 1.09.304l-.573.573a1.33 1.33 0 1 0 .707.707l.573-.573a2.102 2.102 0 1 1-1.797-1.011m0 2.43a.33.33 0 1 0 0-.658.33.33 0 0 0 0 .659"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Target12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconTarget12);
